(function () {
  'use strict';

  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var syncTimer = null;
  var toastTimer = null;
  var lastNoticeAt = 0;

  function cartEndpoint() {
    var base = window.routes && window.routes.cartUrl ? window.routes.cartUrl : '/cart';
    return base.replace(/\.js(?:\?.*)?$/, '') + '.js';
  }

  function displayCount(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;

    return cart.items.reduce(function (total, item) {
      var properties = item.properties || {};
      var isHalfMetre = String(properties._fa_half_metre || '').toLowerCase() === 'true';
      return total + (isHalfMetre ? 1 : Math.max(0, Number(item.quantity) || 0));
    }, 0);
  }

  function updateIndicators(count, animate) {
    var value = Math.max(0, Number(count) || 0);

    Array.prototype.forEach.call(document.querySelectorAll('[data-fa-cart-count], .header__cart-count'), function (counter) {
      counter.textContent = value;
      counter.hidden = value === 0;
      counter.toggleAttribute('aria-hidden', value === 0);

      if (animate && value > 0) {
        counter.classList.remove('fa-cart-count--pop');
        void counter.offsetWidth;
        counter.classList.add('fa-cart-count--pop');
      }
    });

    Array.prototype.forEach.call(document.querySelectorAll('[data-fa-cart-count-wrap]'), function (wrapper) {
      wrapper.hidden = value === 0;
    });

    if (window.theme) window.theme.cartCount = value;
  }

  function ensureToast() {
    var toast = document.querySelector('[data-fa-cart-feedback]');
    if (toast) return toast;

    var isBg = (document.documentElement.lang || '').toLowerCase().indexOf('bg') === 0;
    toast = document.createElement('aside');
    toast.className = 'fa-cart-feedback';
    toast.setAttribute('data-fa-cart-feedback', '');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.setAttribute('aria-atomic', 'true');
    toast.innerHTML =
      '<span class="fa-cart-feedback__check" aria-hidden="true">&#10003;</span>' +
      '<span class="fa-cart-feedback__copy"><strong>' + (isBg ? 'Добавено в количката' : 'Added to cart') + '</strong><small>' + (isBg ? 'Количката ви е обновена' : 'Your cart has been updated') + '</small></span>' +
      '<a class="fa-cart-feedback__link" href="' + ((window.routes && window.routes.cartUrl) || '/cart') + '">' + (isBg ? 'Виж' : 'View') + '</a>';
    document.body.appendChild(toast);
    return toast;
  }

  function showToast() {
    var now = Date.now();
    if (now - lastNoticeAt < 650) return;
    lastNoticeAt = now;

    var toast = ensureToast();
    window.clearTimeout(toastTimer);
    toast.classList.remove('is-visible');
    void toast.offsetWidth;
    toast.classList.add('is-visible');
    toastTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 3600);
  }

  function syncCart(notify) {
    if (!nativeFetch) return;

    nativeFetch(cartEndpoint(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart refresh failed');
      return response.json();
    }).then(function (cart) {
      updateIndicators(displayCount(cart), !!notify);
      if (notify) showToast();
    }).catch(function () {
      /* Keep the normal Shopify cart flow intact if the indicator refresh fails. */
    });
  }

  function scheduleSync(notify) {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(function () {
      syncCart(notify);
    }, notify ? 80 : 140);
  }

  function isCartAddUrl(url) {
    return typeof url === 'string' && /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(url);
  }

  if (nativeFetch) {
    window.fetch = function () {
      var args = arguments;
      var requestUrl = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url);
      var result = nativeFetch.apply(null, args);

      if (isCartAddUrl(requestUrl)) {
        result.then(function (response) {
          if (response && response.ok) scheduleSync(true);
        }).catch(function () {});
      }

      return result;
    };
  }

  if (window.XMLHttpRequest) {
    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__faCartAddRequest = isCartAddUrl(url);
      return nativeOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      if (this.__faCartAddRequest) {
        this.addEventListener('loadend', function () {
          if (this.status >= 200 && this.status < 300) scheduleSync(true);
        }, { once: true });
      }
      return nativeSend.apply(this, arguments);
    };
  }

  document.addEventListener('product:added', function () { scheduleSync(true); });
  document.addEventListener('cart:rerendered', function () { scheduleSync(false); });

  window.addEventListener('pageshow', function () { scheduleSync(false); });
  document.addEventListener('DOMContentLoaded', function () {
    updateIndicators(window.theme && window.theme.cartCount, false);
  });
})();
